import { client_selected } from "../../client";

export const getTermsByLanguage = (currentLanguage: string) => {
  const languageMap: Record<string, keyof typeof client_selected.terms> = {
    "pt-BR": "pt_br",
    "en-US": "en_us",
    es: "es",
  };

  const termsKey = languageMap[currentLanguage] || "pt_br";
  return client_selected.terms[termsKey];
};

export const useTermsByLanguage = () => {
  const { useTranslation } = require("react-i18next");
  const { i18n } = useTranslation();

  return getTermsByLanguage(i18n.language);
};

export const getPrivacyPolicyByLanguage = (currentLanguage: string) => {
  const languageMap: Record<
    string,
    keyof typeof client_selected.privacyPolicy
  > = {
    "pt-BR": "pt_br",
    "en-US": "en_us",
    es: "es",
  };

  const termsKey = languageMap[currentLanguage] || "pt_br";
  return client_selected.privacyPolicy[termsKey];
};

export const usePrivacyPolicyByLanguage = () => {
  const { useTranslation } = require("react-i18next");
  const { i18n } = useTranslation();

  return getPrivacyPolicyByLanguage(i18n.language);
};
